/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */

import React, { useEffect, useState, useMemo } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import {
    Modal,
    ModalTitle,
    TitleSection,
    FullGameDownloadNotAvailableContent,
} from "trux"
import { useVideoSuspenders } from "trux/dist/organisms/VideoPlayer"
import * as links from "../../util/links"
import DownloadMomentWrapper from "../DownloadMomentWrapper"
import { calculateNoOfDaysBeforeExpiration } from "../../util/helpers"
import "./DownloadMomentDialog.css"

const DownloadMomentDialog = ({ onClose, ...props }) => {
    let videoContainer = document.querySelector(".Game .VideoContainer")
    let videoContainerRef = { current: 24 }
    if (videoContainer) {
        let id = videoContainer.id
        id = id.replace("video-container-", "")
        id = parseInt(id, 10)
        videoContainerRef = { current: id }
    }

    const teamName = props.match.params.team_name
    const gameId = props.match.params.game_id
    const playlistId = props.match.params.playlist_id
    const eventNumber = props.match.params.event_number

    const history = useHistory()
    const game = useSelector((state) => state.game.value)
    const extras = useMemo(() => {
        const ex = links.getUrlExtras(window.location.hash)
        return ex
    }, [history.location])
    const open = true
    const [hideTitle, setHideTitle] = useState(false)
    const { suspend, resume } = useVideoSuspenders(videoContainerRef)

    let uploadTIme = game?.subtasks_statuses?.webapp_migration?.update_time
    let expirationDays =
        uploadTIme && calculateNoOfDaysBeforeExpiration(uploadTIme)
    let isFullVideoExpired = !expirationDays && extras.full
    let isFullVideoAvailable = expirationDays && extras.full

    useEffect(() => {
        if (open) {
            suspend()
        }

        return () => {
            if (open) {
                resume()
            }
        }
    }, [open, suspend, resume])

    const close = (e) => {
        history.push(
            `/${teamName}/games/${gameId}/${playlistId}/${eventNumber}/options`
        )
    }

    return (
        <Modal
            trkContext="Download Moment Dialog"
            className="DownloadMoment"
            open={open}
            onShadeClick={close}
        >
            {!hideTitle && (
                <TitleSection onCloseClick={close}>
                    <ModalTitle content="Download highlight" />
                </TitleSection>
            )}
            {!extras.full && open && (
                <DownloadMomentWrapper
                    onClose={close}
                    onSetStep={(step) => {
                        if (step === "auto-add") setHideTitle(true)
                    }}
                    fullGame={false}
                />
            )}
            {extras.full && open && (
                <>
                    {isFullVideoAvailable && open && (
                        <DownloadMomentWrapper
                            forceFullGame={true}
                            onClose={close}
                            expirationDays={expirationDays}
                        />
                    )}
                    {isFullVideoExpired && open && (
                        <FullGameDownloadNotAvailableContent
                            history={history}
                            pathToReplace={"download"}
                        />
                    )}
                </>
            )}
        </Modal>
    )
}
export default DownloadMomentDialog
